var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 8C22.336 8 8 22.336 8 40C8 57.664 22.336 72 40 72C57.664 72 72 57.664 72 40C72 22.336 57.664 8 40 8ZM54.848 29.76C54.368 34.816 52.288 47.104 51.232 52.768C50.784 55.168 49.888 55.968 49.056 56.064C47.2 56.224 45.792 54.848 44 53.664C41.184 51.808 39.584 50.656 36.864 48.864C33.696 46.784 35.744 45.632 37.568 43.776C38.048 43.296 46.24 35.84 46.4 35.168C46.4222 35.0662 46.4193 34.9606 46.3914 34.8602C46.3635 34.7598 46.3115 34.6677 46.24 34.592C46.048 34.432 45.792 34.496 45.568 34.528C45.28 34.592 40.8 37.568 32.064 43.456C30.784 44.32 29.632 44.768 28.608 44.736C27.456 44.704 25.28 44.096 23.648 43.552C21.632 42.912 20.064 42.56 20.192 41.44C20.256 40.864 21.056 40.288 22.56 39.68C31.904 35.616 38.112 32.928 41.216 31.648C50.112 27.936 51.936 27.296 53.152 27.296C53.408 27.296 54.016 27.36 54.4 27.68C54.72 27.936 54.816 28.288 54.848 28.544C54.816 28.736 54.88 29.312 54.848 29.76Z",
    fill: "#115EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bb5309d00207b0acf25545ebea4379a7.svg";
export { ForwardRef as ReactComponent };